import React from 'react';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import { useI18n } from '../../utilities/i18n';
import Breadcrumbs from '../Components/Breadcrumbs';
import { usePools } from '../DatabaseContext';
import Heading from '../Components/Heading';

export default function FormContainer ({ needsValidPool = true, children, title, breadcrumb = [] }) {
    const { pool } = usePools()
    const i18n = useI18n();

    if (needsValidPool && pool && pool.construction_type === 'Other') {
        setTimeout(() => {
            window.location = i18n.forms.unsupportedUrl
        }, 200)

        return <BubbleLoader/>
    }

    return <form onSubmit={e => e.preventDefault()}>

        <Heading>{ title || pool?.name }</Heading>

        <Breadcrumbs items={breadcrumb} />

        <div className="mt-6">
            { children }
        </div>

    </form>;
}
